import { useFlaggedCasesTable } from 'src/components/pages/CoiDisclosures/useFlaggedCasesTable';
import {
  ACTIONS_STATUSES,
  DisclosureMetrics,
  WAITING_STATUSES,
} from '../types';

const COUNT_LIMIT = 1;
const COUNT_PAGE = 1;

export const useDisclosureMetrics = (
  currentUserId: string,
): DisclosureMetrics => {
  const assigned = useFlaggedCasesTable(
    COUNT_LIMIT,
    COUNT_PAGE,
    { reviewer: [currentUserId] },
    undefined,
    '',
  );

  const actions = useFlaggedCasesTable(
    COUNT_LIMIT,
    COUNT_PAGE,
    { status: ACTIONS_STATUSES, reviewer: [currentUserId] },
    undefined,
    '',
  );

  const waiting = useFlaggedCasesTable(
    COUNT_LIMIT,
    COUNT_PAGE,
    { status: WAITING_STATUSES, reviewer: [currentUserId] },
    undefined,
    '',
  );

  return {
    assigned: assigned.count ?? 0,
    actions: actions.count ?? 0,
    waiting: waiting.count ?? 0,
    isLoading: assigned.isLoading || actions.isLoading || waiting.isLoading,
  };
};
